import React ,{Component} from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom';
// Components
import RootLayout from './layouts/RootLayout';
import TryHackMe, { thmLoader } from './pages/TryHackMe';
import Blogs from './pages/Blogs';
import About from './pages/About';
import Home from './pages/Home';
import Post from './pages/Post';
import CheatSheet from './pages/CheatSheet';
import HackTheBox from './pages/HackTheBox'
import Projects, { projectsLoader } from './pages/Projects';
import Contact from './pages/Contact';
// Loader functions
import { htbLoader } from './pages/HackTheBox';
import { blogsLoader } from './pages/Blogs';
import { postLoader } from './pages/Post';

export const getTimeBasedMode = () => {
  const hour = new Date().getHours();
  return hour >= 6 && hour < 18 ? "light" : "dark";
};

const theme = extendTheme({
  config: {
    initialColorMode: getTimeBasedMode(),
    useSystemColorMode: false,
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === "light" ? "#f2f2f0" : undefined,
      },
    }),
  },
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<RootLayout/>}>
      <Route index element ={<Home />}/>
      <Route path="about" element={<About />}/>
      <Route path="posts" >
        <Route
          index
          loader={blogsLoader}
          element={<Blogs/>}
        />
        <Route path="/posts/:slug"
          loader={postLoader}
          element={<Post />}
        />
      </Route>
      <Route path="tryhackme" >
        <Route
          index
          loader={thmLoader}
          element={<TryHackMe />}
        />
      </Route>
      <Route path="hackthebox" >
        <Route
          index
          loader={htbLoader}
          element={<HackTheBox />}
        />
      </Route>
      <Route path="projects" >
        <Route
          index
          loader={projectsLoader}
          element={<Projects />}
        />
      </Route>
      <Route path="cheatsheet" >
        <Route
          index
          loader={projectsLoader}
          element={<CheatSheet />}
        />
      </Route>
      <Route path="contact" element={<Contact />} />
    </Route>

  )
)

class App extends Component {
  render(){

    return (
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider>
    </HelmetProvider>
  );
  }
}

export default App;
